export default function getInfoBarMessageIdsInCompose(viewState) {
    return viewState.infoBarIds;
}
//# sourceMappingURL=getInfoBarMessageIdsInCompose.js.map